import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';

@Component({
  selector: 'cv-milestone-badges-renderer',
  templateUrl: './milestone-badges-renderer.component.html',
  styleUrls: ['./milestone-badges-renderer.component.scss']
})
export class MilestoneBadgesRendererComponent implements AgRendererComponent {
  
  params!: ICellRendererParams;
  badges: any;
  gs: any = null;

  constructor(
    private gamesService: GamesService
  ) { 
    this.gs = this.gamesService.data;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if(this.params != null ){
      this.badges = this.params.value;
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;

    if(this.params != null ){
      this.badges = this.params.value;
    }

    return true;
  }

  isNumeric(value: any){
    return (typeof value === 'number') ? true : false;
  }
}